export default (reducerFn, loadingTypes = [], submittingTypes = [], actionsPrefix = '') => (state, action) => {
  const nextState = reducerFn(state, action);
  switch (true) {
    case loadingTypes.includes(action.type):
      return { ...nextState, loading: true };
    case submittingTypes.includes(action.type):
      return { ...nextState, submitting: true };
    case action.type.indexOf(actionsPrefix) === 0:
      return { ...nextState, loading: false, submitting: false };
    default:
      return { ...nextState };
  }
};
